import noDataImage from '../Assets/images/no-data.svg'

const NoData = ({ title = 'No Data tracked', subtext = 'Create new time entries to your tracker', action }) => {
  return (
      <div className="no-data-container">
        <img src={noDataImage} alt="No Data" className="no-data-image" />
        <div className="no-data-text">
            <h6>{title}</h6>
            <p className="no-data-subtext">{subtext}</p>
            {action}
        </div>
      </div>
  )
}

export default NoData
